// extracted by mini-css-extract-plugin
export default {"skipdatecontain":"bZ","skip_info":"cZ","skipped":"eZ","modify_order":"fZ","cancel_subscription_btn":"gZ","byb":"hZ","modify_order_outer":"iZ","byb_edit_btn":"jZ","modify_order_item":"kZ","cancel_copy_wrapper":"lZ","cancelled_copy":"mZ"};
    if(module.hot) {
      // 1726593107732
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  